export const PLACEHOLDER = {
  fullName: "First and last name",
  email: "name@example.com",
  password: "Password",

  companyName: "Workspace name",
  /** A shared mailbox, not a person - see the column comment on `companies.email`. */
  companyEmail: "safety@example.com",
  website: "https://example.com",

  siteName: "Depot, yard or address",

  appointmentTitle: "Maintenance visit",
  customer: "Customer name",
  address: "Street address",
  workOrder: "Work order number",
  scopeOfWork: "Work to be done",
  notes: "Special instructions or technician notes",
  cancelReason: "Customer postponed",
} as const;
